import type { IconData } from '@stacksjs/iconify-core'

export const forkPlate: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45.5 4c-11.046 0-20 8.954-20 20s8.954 20 20 20\"/><path d=\"M45.5 12c-6.627 0-12 5.373-12 12s5.373 12 12 12M19.945 6.358c.46 2.718 1.104 7.467 1.052 12.538c-.026 2.617-1.774 4.962-4.522 5.578c-.568.127-1.173.242-1.805.331l1.784 13.933c.314 2.451-1.195 4.88-3.645 5.2c-.303.039-.58.062-.809.062a7 7 0 0 1-.81-.063c-2.45-.32-3.958-2.748-3.644-5.199L9.33 24.805a23 23 0 0 1-1.804-.33c-2.749-.617-4.497-2.963-4.524-5.58c-.051-5.07.591-9.818 1.051-12.536C4.287 4.974 5.499 4 6.903 4h10.192c1.405 0 2.616.973 2.85 2.358M9.5 4L9 15m5.5-11l.5 11\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default forkPlate
